import Slider from "react-slick";
import Image from 'next/image';
import {useForm} from 'react-hook-form';
import {get, isEmpty} from 'lodash';
import {useRouter} from 'next/router';
import http from "utilities/http";
import {useEffect, useState} from "react";
import Error from "components/error";
import {EMAIL_FORGOT} from 'utilities/constants';
import {Loader} from "../../components/loader";

export default function login() {
    const {register, handleSubmit, setError, formState: {errors}} = useForm();
    const route = useRouter();
    const settings = {
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    const [state, _setState] = useState({
        email: '',
        time: 0,
        otp: '',
    });
    const setState = (_state = {}) => {
        _setState((state) => ({
            ...state,
            ..._state
        }));
    };
    const formForgotPassword = async (value) => {
        setLoading(true);
        const res = await http('password/forgot', {}, {
            method: 'POST',
            body: {
                email: value.email,
            }
        }, 'v2');

        if (get(res, ['success']) === false) {
            setError("email", {
                type: "manual",
                message: res.message,
            });
            setLoading(false);
        } else {
            localStorage.setItem(EMAIL_FORGOT, value.email);
            route.push('/forgot-password/otp');
        }
    };
    const [loading,setLoading] = useState(false);
    return <div className="login">
        <Loader loading={loading}/>
        <div className="login-info">
            <div className="loginWrap">
                <div className="logo"><a href="#"><Image src="/images/logo.svg" alt="" width={248} height={57}/></a>
                </div>
                <div className="slider sliderBanner">
                    <Slider {...settings}>
                        <div className="bannerWrap">
                            <div className="bannerThumb">
                                <Image src="/images/banner-login.svg" alt="" width={357} height={364}/>
                            </div>
                            <div className="bannerText">
                                <p className="tlt">Tìm kiếm ý tưởng tuyệt vời!</p>
                                <p className="text">Bạn cần ý tưởng, cảm hứng về chuyện nhà, Happynest luôn có, giúp bạn
                                    dễ dàng tìm được ý tưởng tuyệt vời.</p>
                            </div>
                        </div>
                        <div className="bannerWrap">
                            <div className="bannerThumb">
                                <Image src="/images/banner-login.svg" alt="" width={357} height={364}/>
                            </div>
                            <div className="bannerText">
                                <p className="tlt">Tìm kiếm ý tưởng tuyệt vời!</p>
                                <p className="text">Bạn cần ý tưởng, cảm hứng về chuyện nhà, Happynest luôn có, giúp
                                    bạn
                                    dễ dàng tìm được ý tưởng tuyệt vời.</p>
                            </div>
                        </div>
                        <div className="bannerWrap">
                            <div className="bannerThumb">
                                <Image src="/images/banner-login.svg" alt="" width={357} height={364}/>
                            </div>
                            <div className="bannerText">
                                <p className="tlt">Tìm kiếm ý tưởng tuyệt vời!</p>
                                <p className="text">Bạn cần ý tưởng, cảm hứng về chuyện nhà, Happynest luôn có, giúp
                                    bạn
                                    dễ dàng tìm được ý tưởng tuyệt vời.</p>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>
        </div>
        <div className="login-form">
            <div className="formWrap">
                <form onSubmit={handleSubmit(formForgotPassword)}>
                    <div className="logo"><a href="#"><Image src="/images/logo.svg" alt="" width={140} height={32}/></a>
                    </div>

                    <h1 className="title">Quên mật khẩu</h1>
                    <p className="form-note">Nhập email của bạn khi đăng ký tài khoản <br/>để khôi phục mật khẩu
                    </p>
                    <div className="groupForm">
                        {/*form-control-danger*/}
                        <input className="form-control"
                            type="text"  {...register('email', {
                                required: 'Điền email',
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: 'Email không đúng định dạng',
                                }
                            })}
                            placeholder="Nhập email"/>
                        <Error errors={errors} name="email"/>
                    </div>
                    <div className="groupForm-btn">
                        <button type="submit" className="btn btn--blue">Tiếp tục</button>
                    </div>
                  
                </form>
            </div>
            <p className="copyright">© Happynest, JSC.. All Rights Reserved</p>
        </div>
    </div>;

}
